import React from 'react';
import PropTypes from 'prop-types';
import { formatPrice, getProductSalePrice } from '../../../utils/utils';
import useLang from '../../../hooks/useLang';
import { useTranslation } from 'react-i18next';
import { Chip } from 'primereact/chip';

const ProductDetails = (props) => {
    const product = props.product;
    const variation = props.defaultVar;
    const { t } = useTranslation();
    const itemPrice = getProductSalePrice({
        selling_price: product.selling_price,
        discounted_price: product.discounted_price,
        discount_end_date: product.discount_end_date,
        discount_start_date: product.discount_start_date,
    });
    const lang = useLang();
    return (
        <div className='lg:p-4 p-2 lg:mx-4 mx-2'>
            <h2 className='lg:text-5xl text-3xl leading-[1.2]'>{lang === "en" ? product.name : product.name_ar}</h2>
            <div className='my-4 break-words whitespace-pre-wrap'
                dangerouslySetInnerHTML={{
                    __html: lang === "en" ? product.short_description : product.short_description_ar
                }}
            >
            </div>
            {
                variation !== undefined &&
                <div className='mb-3'>
                    {
                        variation.variationValues.map((v) => {
                            return (
                                <Chip label={(lang === "en" ? v.type : v.type_ar) + ' - ' + v.value} key={v.type} className='m-1 tiny-chips rounded-chip outlined-chip border-1' />
                            );
                        })
                    }
                </div>
            }
            <div>
                <div className='flex items-center mb-1'>
                     <span>{t('stock')}</span>
                    <span className='mx-2'>-</span>
                    <span className='font-semibold'>{t('available')}</span>
                </div>
                <div className='mb-1 flex items-center'>
                    <span>{t('category')}</span>
                    <span className='mx-2'>-</span>
                    <span className='font-semibold'>{lang === "en" ? product.category_name : product.category_name_ar}</span>
                </div>
                {
                    product.brand !== null &&
                    <div className='mb-1 flex items-center'>
                        <span>{t('brand')}</span>
                        <span className='mx-2'>-</span>
                        <span className='font-semibold'>{lang === "en" ? product.brand_name : product.brand_name_ar}</span>
                    </div>
                }
            </div>
            <h1 className='text-3xl mt-5'>
                <strong>{itemPrice.price}</strong>
                {
                    (itemPrice.discount) &&
                    <span>
                        <span className=" text-xl mx-1"
                            style={{
                                textDecorationLine: "line-through"
                            }}
                        >{formatPrice(product.selling_price, false)}</span>
                    </span>

                }
            </h1>
        </div>
    );
}
ProductDetails.propTypes = {
    product: PropTypes.object.isRequired,
    defaultVar: PropTypes.object.isRequired
}
export default ProductDetails;